/*
 * action types
 */

import GET_ALL_EARNINGS from "src/graphql/queries/getAllEarnings.gql";
import GET_PAGINATED_EARNINGS from "src/graphql/queries/getPaginatedEarnings.gql";
import GET_INVOICE_STATS from "src/graphql/queries/getInvoiceStats.gql";
import GET_MONTHLY_STATS from "src/graphql/queries/getMonthlyStats.gql";
import GET_AVAILABLE_YEARS from "src/graphql/queries/getAvailableYears.gql";
import UPDATE_EARNING_MUTATION from "src/graphql/mutations/updateEarning.gql";

export async function getAllEarnings(client) {
  const data = await client.query({
    query: GET_ALL_EARNINGS,
    fetchPolicy: "network-only",
  });

  return data.data.Gains.list;
}

export async function updateEarning(input, client) {
  console.log("in action", input);
  const data = await client.mutate({
    mutation: UPDATE_EARNING_MUTATION,
    variables: {input},
  });

  return data.data.Gains.update;
}

export async function fetchPaginatedEarnings(client, {limit = 25, offset = 0, year, type} = {}) {
  const data = await client.query({
    query: GET_PAGINATED_EARNINGS,
    fetchPolicy: "network-only",
    variables: {limit, offset, year, type},
  });
  return data.data.Gains.paginatedList;
}

export async function fetchMonthlyStats(client, {year, userId, needTva}) {
  const data = await client.query({
    query: GET_MONTHLY_STATS,
    fetchPolicy: "network-only",
    variables: {year, userId, needTva},
  });
  return data.data.Gains.monthlyStats;
}

export async function fetchAvailableYears(client) {
  const data = await client.query({
    query: GET_AVAILABLE_YEARS,
    fetchPolicy: "network-only",
  });
  return data.data.Gains.availableYears || [];
}

export async function fetchInvoiceStats(client, year) {
  const data = await client.query({
    query: GET_INVOICE_STATS,
    fetchPolicy: "network-only",
    variables: {year},
  });
  return data.data.Gains.invoiceStats;
}
